export default "__VITE_ASSET__CTAo2$Ev__"